{
  "CONTACT_PANEL": {
    "CONFIRM": {
      "YES": "OK",
      "CANCEL": "Odustani"
    },
    "NOT_AVAILABLE": "Nije dostupno",
    "EMAIL_ADDRESS": "Adresa e-pošte",
    "PHONE_NUMBER": "Broj telefona",
    "WHATSAPP_USERNAME": "WhatsApp korisničko ime",
    "IDENTIFIER": "Identifikator",
    "COPY_SUCCESSFUL": "Uspješno kopirano u međuspremnik",
    "COPY_NAME": "Kopiraj ime",
    "COPY_REFERER": "Kopiraj URL",
    "COMPANY": "Tvrtka",
    "LOCATION": "Lokacija",
    "LTV": "LTV",
    "BROWSER_LANGUAGE": "Jezik preglednika",
    "CONVERSATION_LANGUAGE": "Jezik razgovora",
    "CONVERSATION_TITLE": "Detalji razgovora",
    "VIEW_PROFILE": "Prikaži profil",
    "BROWSER": "Preglednik",
    "OS": "Operacijski sustav",
    "INITIATED_FROM": "Pokrenuto s",
    "INITIATED_AT": "Pokrenuto u",
    "IP_ADDRESS": "IP adresa",
    "CREATED_AT_LABEL": "Izrađen",
    "NEW_MESSAGE": "Nova poruka",
    "CONVERSATIONS": {
      "NO_RECORDS_FOUND": "Nema prethodnih razgovora povezanih s ovim kontaktom.",
      "TITLE": "Prethodni razgovori"
    },
    "LABELS": {
      "CONTACT": {
        "TITLE": "Oznake kontakta",
        "ERROR": "Oznake nije moguće ažurirati"
      },
      "CONVERSATION": {
        "TITLE": "Oznake razgovora",
        "ADD_BUTTON": "Dodaj oznake"
      },
      "LABEL_SELECT": {
        "TITLE": "Dodaj oznake",
        "PLACEHOLDER": "Pretraži oznake",
        "NO_RESULT": "Nema pronađenih oznaka",
        "CREATE_LABEL": "Kreiraj novu oznaku"
      }
    },
    "MERGE_CONTACT": "Spoji kontakt",
    "CONTACT_ACTIONS": "Radnje kontakta",
    "MUTE_CONTACT": "Blokiraj kontakt",
    "MUTE_CONTACT_DISABLED": "Ne može se koristiti. Cijela domena kontakta je blokirana.",
    "UNMUTE_CONTACT": "Deblokiraj kontakt",
    "BLOCK_CONTACT_DOMAIN": "Blokiraj domenu kontakta",
    "UNBLOCK_CONTACT_DOMAIN": "Deblokiraj domenu kontakta",
    "BLOCK_CONTACT_DOMAIN_DISABLED": "Ova domena kontakta ne može se blokirati.",
    "BLOCK_CONTACT_DOMAIN_MESSAGE": "Blokiranje domene blokirat će sve postojeće i buduće kontakte za tu domenu.",
    "UNBLOCK_CONTACT_DOMAIN_MESSAGE": "Deblokiranje domene uklonit će blokadu sa svih kontakata za tu domenu (uključujući one ručno blokirane).",
    "BLOCK_PUBLIC_DOMAIN_TITLE": "Javna domena e-pošte",
    "BLOCK_PUBLIC_DOMAIN_MESSAGE": "{domain} je javna domena e-pošte koju koriste mnogi nepovezani pošiljatelji, stoga se ne može blokirati u cijelosti. Želite li blokirati samo ovu adresu ({email})?",
    "BLOCK_ONLY_THIS_ADDRESS": "Blokiraj samo ovu adresu",
    "MUTED_SUCCESS": "Ovaj kontakt je uspješno blokiran. Njegovi razgovori uskoro će biti riješeni u pozadini.",
    "UNMUTED_SUCCESS": "Ovaj kontakt je uspješno deblokiran.",
    "OPEN_JARABOT": "Otvori povijest AI odgovora",
    "TRANSLATE_CONVERSATION": "Prevedi razgovor",
    "TRANSLATE_INITIATED": "Prijevod je započeo. Za duže razgovore ovo može potrajati.",
    "TRANSLATE_SUCCESS": "Prijevod razgovora je uspješno završen.",
    "TRANSLATE_ERROR": "Prijevod razgovora nije uspio. Pokušajte ponovno.",
    "MOVE_CONVERSATION": "Premjesti razgovor",
    "MOVE_CONVERSATION_MISSING_EMAIL": "E-mail kontakta je obavezan za premještanje razgovora u e-mail sandučić",
    "MERGE_CONVERSATION": "Spoji razgovor",
    "CONTACT_DOMAIN_BLOCKED_SUCCESS": "Ova domena je uspješno blokirana. Više nećete biti obaviješteni o budućim razgovorima.",
    "CONTACT_DOMAIN_UNBLOCKED_SUCCESS": "Ova domena je uspješno deblokirana.",
    "SEND_TRANSCRIPT": "Pošalji transkript",
    "EDIT_LABEL": "Uredi",
    "SIDEBAR_SECTIONS": {
      "CUSTOM_ATTRIBUTES": "Prilagođeni atributi",
      "CONTACT_LABELS": "Oznake kontakta",
      "PREVIOUS_CONVERSATIONS": "Prethodni razgovori",
      "NO_RECORDS_FOUND": "Nema pronađenih atributa"
    }
  },
  "EDIT_CONTACT": {
    "BUTTON_LABEL": "Uredi kontakt",
    "TITLE": "Uredi kontakt",
    "DESC": "Uredite podatke kontakta"
  },
  "DELETE_CONTACT": {
    "BUTTON_LABEL": "Izbriši kontakt",
    "TITLE": "Izbriši kontakt",
    "DESC": "Izbrišite podatke kontakta",
    "CONFIRM": {
      "TITLE": "Potvrdi brisanje",
      "MESSAGE": "Jeste li sigurni da želite izbrisati ",
      "YES": "Da, izbriši",
      "NO": "Ne, zadrži"
    },
    "API": {
      "SUCCESS_MESSAGE": "Contact deleted successfully",
      "ERROR_MESSAGE": "Kontakt nije moguće izbrisati. Pokušajte ponovno kasnije."
    }
  },
  "CONTACT_FORM": {
    "FORM": {
      "SUBMIT": "Spremi",
      "CANCEL": "Odustani",
      "AVATAR": {
        "LABEL": "Profilna slika kontakta"
      },
      "NAME": {
        "PLACEHOLDER": "Unesite ime i prezime kontakta",
        "LABEL": "Ime i prezime"
      },
      "BIO": {
        "PLACEHOLDER": "Unesite opis kontakta",
        "LABEL": "O meni"
      },
      "EMAIL_ADDRESS": {
        "PLACEHOLDER": "Unesite adresu e-pošte kontakta",
        "LABEL": "Adresa e-pošte",
        "DUPLICATE": "Ovu adresu e-pošte već koristi drugi kontakt.",
        "ERROR": "Unesite ispravnu adresu e-pošte."
      },
      "PHONE_NUMBER": {
        "PLACEHOLDER": "Unesite broj telefona kontakta",
        "LABEL": "Broj telefona",
        "HELP": "Phone number should be of E.164 format eg: +1415555555 [+][country code][area code][local phone number]",
        "ERROR": "Broj telefona mora biti prazan ili u formatu E.164",
        "DIAL_CODE_ERROR": "Odaberite pozivni broj s popisa",
        "DUPLICATE": "Ovaj broj telefona već koristi drugi kontakt."
      },
      "LOCATION": {
        "PLACEHOLDER": "Unesite lokaciju kontakta",
        "LABEL": "Lokacija"
      },
      "COMPANY_NAME": {
        "PLACEHOLDER": "Unesite naziv tvrtke",
        "LABEL": "Naziv tvrtke"
      },
      "COUNTRY": {
        "PLACEHOLDER": "Unesi ime zemlje",
        "LABEL": "Ime zemlje",
        "SELECT_PLACEHOLDER": "Odaberi",
        "REMOVE": "Izbaci",
        "SELECT_COUNTRY": "Odaberi zemlju"
      },
      "CITY": {
        "PLACEHOLDER": "Unesi ime grada",
        "LABEL": "Ime grada"
      },
      "SOCIAL_PROFILES": {
        "FACEBOOK": {
          "PLACEHOLDER": "Unesite Facebook korisničko ime",
          "LABEL": "Facebook"
        },
        "TWITTER": {
          "PLACEHOLDER": "Unesite Twitter korisničko ime",
          "LABEL": "Twitter"
        },
        "LINKEDIN": {
          "PLACEHOLDER": "Unesite LinkedIn korisničko ime",
          "LABEL": "LinkedIn"
        },
        "GITHUB": {
          "PLACEHOLDER": "Unesite Github korisničko ime",
          "LABEL": "Github"
        }
      },
      "UNSAVED_CHANGES": {
        "TITLE": "Nespremljene promjene",
        "DESCRIPTION": "Imate nespremljene promjene. Želite li ih spremiti prije zatvaranja?",
        "CONFIRM": "Spremi",
        "CANCEL": "Odbaci"
      }
    },
    "DELETE_AVATAR": {
      "API": {
        "SUCCESS_MESSAGE": "Profilna slika kontakta je uspješno izbrisana",
        "ERROR_MESSAGE": "Profilnu sliku kontakta nije moguće izbrisati. Pokušajte ponovno kasnije."
      }
    },
    "SUCCESS_MESSAGE": "Kontakt je uspješno spremljen",
    "ERROR_MESSAGE": "Došlo je do pogreške, pokušajte ponovno"
  },
  "NEW_CONVERSATION": {
    "BUTTON_LABEL": "Započni razgovor",
    "TITLE": "Novi razgovor",
    "DESC": "Započnite novi razgovor slanjem nove poruke.",
    "NO_INBOX": "Nije pronađen sandučić za pokretanje novog razgovora s ovim kontaktom.",
    "FORM": {
      "TO": {
        "LABEL": "Za"
      },
      "INBOX": {
        "LABEL": "Inbox",
        "PLACEHOLDER": "Izaberi izvorišni inbox",
        "ERROR": "Odaberite sandučić"
      },
      "SUBJECT": {
        "LABEL": "Predmet",
        "PLACEHOLDER": "Predmet",
        "ERROR": "Predmet ne može biti prazan"
      },
      "MESSAGE": {
        "LABEL": "Poruka",
        "PLACEHOLDER": "Ovdje napišite poruku",
        "ERROR": "Poruka ne može biti prazna"
      },
      "ATTACHMENTS": {
        "SELECT": "Odaberi datoteke",
        "HELP_TEXT": "Povucite i ispustite datoteke ovdje ili odaberite datoteke za privitak"
      },
      "SUBMIT": "Pošalji poruku",
      "CANCEL": "Odustani",
      "SUCCESS_MESSAGE": "Poruka je poslana!",
      "GO_TO_CONVERSATION": "Prikaži",
      "ERROR_MESSAGE": "Slanje nije uspjelo. Pokušajte ponovno."
    }
  },
  "CONTACTS_PAGE": {
    "LIST": {
      "TABLE_HEADER": {
        "SOCIAL_PROFILES": "Društveni profili"
      }
    }
  },
  "CUSTOM_ATTRIBUTES": {
    "BUTTON": "Dodaj prilagođeni atribut",
    "COPY_SUCCESSFUL": "Uspješno kopirano u međuspremnik",
    "SHOW_MORE": "Prikaži sve atribute",
    "SHOW_LESS": "Prikaži manje atributa",
    "ACTIONS": {
      "COPY": "Kopiraj atribut",
      "DELETE": "Izbriši atribut",
      "EDIT": "Uredi atribut"
    },
    "ADD": {
      "TITLE": "Kreiraj prilagođeni atribut",
      "DESC": "Dodajte prilagođene podatke ovom kontaktu."
    },
    "FORM": {
      "CREATE": "Dodaj atribut",
      "CANCEL": "Odustani",
      "NAME": {
        "LABEL": "Naziv prilagođenog atributa",
        "PLACEHOLDER": "Npr.: shopify id",
        "ERROR": "Neispravan naziv prilagođenog atributa"
      },
      "VALUE": {
        "LABEL": "Vrijednost atributa",
        "PLACEHOLDER": "Npr.: 11901 "
      },
      "ADD": {
        "TITLE": "Kreiraj novi atribut ",
        "SUCCESS": "Atribut je uspješno dodan",
        "ERROR": "Atribut nije moguće dodati. Pokušajte ponovno kasnije"
      },
      "UPDATE": {
        "SUCCESS": "Atribut je uspješno ažuriran",
        "ERROR": "Atribut nije moguće ažurirati. Pokušajte ponovno kasnije"
      },
      "DELETE": {
        "SUCCESS": "Atribut je uspješno izbrisan",
        "ERROR": "Atribut nije moguće izbrisati. Pokušajte ponovno kasnije"
      },
      "ATTRIBUTE_SELECT": {
        "TITLE": "Dodaj atribute",
        "PLACEHOLDER": "Pretraži atribute",
        "NO_RESULT": "Nema pronađenih atributa"
      },
      "ATTRIBUTE_TYPE": {
        "LIST": {
          "PLACEHOLDER": "Odaberi vrijednost",
          "SEARCH_INPUT_PLACEHOLDER": "Pretraži vrijednosti",
          "NO_RESULT": "Nema pronađenih rezultata"
        }
      }
    },
    "VALIDATIONS": {
      "REQUIRED": "Potrebna je ispravna vrijednost",
      "INVALID_URL": "Neispravan URL",
      "INVALID_INPUT": "Neispravan unos"
    }
  },
  "MERGE_CONTACTS": {
    "TITLE": "Spoji kontakte",
    "DESCRIPTION": "Merge contacts to combine two profiles into one, including all attributes and conversations. In case of conflict, the Primary contact’ s attributes will take precedence.",
    "PRIMARY": {
      "TITLE": "Primarni kontakt",
      "HELP_LABEL": "Bit će izbrisan"
    },
    "PARENT": {
      "TITLE": "Kontakt za spajanje",
      "PLACEHOLDER": "Pretraži kontakt",
      "HELP_LABEL": "Bit će zadržan"
    },
    "SUMMARY": {
      "TITLE": "Sažetak",
      "DELETE_WARNING": "Kontakt <strong>{primaryContactName}</strong> bit će izbrisan.",
      "ATTRIBUTE_WARNING": "Podaci kontakta <strong>{primaryContactName}</strong> bit će kopirani u <strong>{parentContactName}</strong>."
    },
    "SEARCH": {
      "ERROR_MESSAGE": "Nešto nije u redu. Pokušajte ponovno kasnije."
    },
    "FORM": {
      "SUBMIT": " Merge contacts",
      "CANCEL": "Odustani",
      "CHILD_CONTACT": {
        "ERROR": "Odaberite podređeni kontakt za spajanje"
      },
      "SUCCESS_MESSAGE": "Kontakt je uspješno spojen",
      "ERROR_MESSAGE": "Kontakte nije moguće spojiti. Pokušajte ponovno!"
    },
    "DROPDOWN_ITEM": {
      "ID": "(ID: {identifier})"
    }
  },
  "CONTACTS_LAYOUT": {
    "HEADER": {
      "TITLE": "Kontakti",
      "SEARCH_TITLE": "Pretraži kontakte",
      "SEARCH_PLACEHOLDER": "Pretraži...",
      "MESSAGE_BUTTON": "Poruka",
      "SEND_MESSAGE": "Pošalji poruku",
      "SHOW_DETAILS": "Pojedinosti kontakta",
      "BLOCKING": "Blokiranje",
      "BLOCK_CONTACT": "Blokiraj kontakt",
      "UNBLOCK_CONTACT": "Deblokiraj kontakt",
      "BLOCK_CONTACT_MESSAGE": "Blokiranje ovog kontakta spriječit će ih da kreiraju nove razgovore, a svi njihovi postojeći razgovori bit će riješeni. Jeste li sigurni da želite blokirati ovaj kontakt?",
      "UNBLOCK_CONTACT_MESSAGE": "Deblokiranje ovog kontakta omogućit će im kreiranje novih razgovora. Jeste li sigurni da želite deblokirati ovaj kontakt?",
      "BLOCK_CONTACT_DISABLED": "Ne može se koristiti. Cijela domena kontakta je blokirana.",
      "BLOCK_CONTACT_DOMAIN": "Blokiraj domenu kontakta",
      "UNBLOCK_CONTACT_DOMAIN": "Deblokiraj domenu kontakta",
      "BLOCK_CONTACT_DOMAIN_DISABLED": "Ova domena kontakta ne može se blokirati.",
      "BLOCK_CONTACT_DOMAIN_MESSAGE": "Blokiranje domene blokirat će sve postojeće i buduće kontakte za tu domenu.",
      "UNBLOCK_CONTACT_DOMAIN_MESSAGE": "Deblokiranje domene uklonit će blokadu sa svih kontakata za tu domenu (uključujući one ručno blokirane).",
      "BLOCK_PUBLIC_DOMAIN_TITLE": "Javna domena e-pošte",
      "BLOCK_PUBLIC_DOMAIN_MESSAGE": "{domain} je javna domena e-pošte koju koriste mnogi nepovezani pošiljatelji, stoga se ne može blokirati u cijelosti. Želite li blokirati samo ovaj kontakt ({email})?",
      "BLOCK_ONLY_THIS_CONTACT": "Blokiraj samo ovaj kontakt",
      "DIAL": "Nazovi",
      "BREADCRUMB": {
        "CONTACTS": "Kontakti"
      },
      "ACTIONS": {
        "CONTACT_CREATION": {
          "ADD_CONTACT": "Dodaj kontakt",
          "EXPORT_CONTACT": "Izvezi kontakte",
          "IMPORT_CONTACT": "Uvezi kontakte",
          "SAVE_CONTACT": "Spremi kontakt",
          "EMAIL_ADDRESS_DUPLICATE": "Ovu adresu e-pošte već koristi drugi kontakt.",
          "PHONE_NUMBER_DUPLICATE": "Ovaj broj telefona već koristi drugi kontakt.",
          "SUCCESS_MESSAGE": "Kontakt je uspješno spremljen",
          "ERROR_MESSAGE": "Kontakt nije moguće spremiti. Pokušajte ponovno kasnije."
        },
        "BLOCK_SUCCESS_MESSAGE": "Ovaj kontakt je uspješno blokiran. Njegovi razgovori uskoro će biti riješeni u pozadini.",
        "BLOCK_ERROR_MESSAGE": "Kontakt nije moguće blokirati. Pokušajte ponovno kasnije.",
        "UNBLOCK_SUCCESS_MESSAGE": "Ovaj kontakt je uspješno deblokiran",
        "UNBLOCK_ERROR_MESSAGE": "Kontakt nije moguće deblokirati. Pokušajte ponovno kasnije.",
        "IMPORT_CONTACT": {
          "TITLE": "Uvezi kontakte",
          "DESCRIPTION": "Uvezite kontakte putem CSV datoteke.",
          "DOWNLOAD_LABEL": "Preuzmite primjer CSV datoteke.",
          "LABEL": "CSV datoteka:",
          "CHOOSE_FILE": "Odaberi datoteku",
          "CHANGE": "Promijeni",
          "CANCEL": "Odustani",
          "IMPORT": "Uvezi",
          "SUCCESS_MESSAGE": "Obavijest ćete primiti e-poštom kada uvoz završi.",
          "ERROR_MESSAGE": "Došlo je do pogreške, molimo pokušajte ponovo"
        },
        "EXPORT_CONTACT": {
          "TITLE": "Izvezi kontakte",
          "DESCRIPTION": "Brzo izvezite CSV datoteku sa svim podacima o vašim kontaktima",
          "CONFIRM": "Izvezi",
          "SUCCESS_MESSAGE": "Export is in progress, You will be notified via email when export file is ready to dowanlod.",
          "ERROR_MESSAGE": "Došlo je do pogreške, molimo pokušajte ponovo"
        },
        "SORT_BY": {
          "LABEL": "Poredaj po",
          "OPTIONS": {
            "NAME": "Ime",
            "EMAIL": "Email",
            "PHONE_NUMBER": "Broj telefona",
            "COMPANY": "Tvrtka",
            "COUNTRY": "Država",
            "CITY": "Grad",
            "LAST_ACTIVITY": "Zadnja aktivnost",
            "CREATED_AT": "Kreirano"
          }
        },
        "ORDER": {
          "LABEL": "Redoslijed",
          "OPTIONS": {
            "ASCENDING": "Uzlazno",
            "DESCENDING": "Silazno"
          }
        },
        "FILTERS": {
          "CREATE_SEGMENT": {
            "TITLE": "Želite li spremiti ovaj filteri?",
            "CONFIRM": "Spremi filter",
            "LABEL": "Ime",
            "PLACEHOLDER": "Unesite naziv filtera",
            "ERROR": "Unesite ispravan naziv",
            "SUCCESS_MESSAGE": "Filter je uspješno spremljen",
            "ERROR_MESSAGE": "Filter nije moguće spremiti. Pokušajte ponovno kasnije."
          },
          "DELETE_SEGMENT": {
            "TITLE": "Potvrdi brisanje",
            "DESCRIPTION": "Jeste li sigurni da želite izbrisati ovaj filter?",
            "CONFIRM": "Da, izbriši",
            "CANCEL": "Ne, odustani",
            "SUCCESS_MESSAGE": "Filter je uspješno izbrisan",
            "ERROR_MESSAGE": "Filter nije moguće izbrisati. Pokušajte ponovno kasnije."
          }
        }
      }
    },
    "PAGINATION_FOOTER": {
      "SHOWING": "Prikazano {startItem} – {endItem} od {totalItems} kontakata"
    },
    "FILTER": {
      "NAME": "Ime",
      "EMAIL": "Email",
      "PHONE_NUMBER": "Broj telefona",
      "IDENTIFIER": "Identifikator",
      "COUNTRY": "Država",
      "CITY": "Grad",
      "CREATED_AT": "Kreirano",
      "LAST_ACTIVITY": "Zadnja aktivnost",
      "REFERER_LINK": "Povezica preporuke",
      "BLOCKED": "Blokiran",
      "BLOCKED_TRUE": "Istina",
      "BLOCKED_FALSE": "Neistina",
      "BUTTONS": {
        "CLEAR_FILTERS": "Očisti filtre",
        "UPDATE_SEGMENT": "Ažuriraj segment",
        "APPLY_FILTERS": "Primijeni filtre",
        "ADD_FILTER": "Dodaj filter"
      },
      "TITLE": "Filtriraj kontakte",
      "EDIT_SEGMENT": "Uredi segment",
      "SEGMENT": {
        "LABEL": "Naziv segmenta",
        "INPUT_PLACEHOLDER": "Unesite naziv segmenta"
      },
      "ACTIVE_FILTERS": {
        "MORE_FILTERS": "+ još {count} filtera",
        "CLEAR_FILTERS": "Očisti filtre"
      }
    },
    "CARD": {
      "OF": "od",
      "VIEW_DETAILS": "Prikaži detalje",
      "EDIT_DETAILS_FORM": {
        "TITLE": "Uredi podatke kontakta",
        "FORM": {
          "FIRST_NAME": {
            "PLACEHOLDER": "Unesite ime",
            "ERROR": "Ime je obavezno."
          },
          "LAST_NAME": {
            "PLACEHOLDER": "Unesite prezime"
          },
          "EMAIL_ADDRESS": {
            "PLACEHOLDER": "Unesite adresu e-pošte",
            "DUPLICATE": "Ovu adresu e-pošte već koristi drugi kontakt.",
            "ERROR": "Unesite ispravnu adresu e-pošte."
          },
          "PHONE_NUMBER": {
            "PLACEHOLDER": "Unesite broj telefona",
            "DUPLICATE": "Ovaj broj telefona već koristi drugi kontakt."
          },
          "CITY": {
            "PLACEHOLDER": "Unesi ime grada"
          },
          "COUNTRY": {
            "PLACEHOLDER": "Odaberi zemlju"
          },
          "BIO": {
            "PLACEHOLDER": "Unesite opis"
          },
          "COMPANY_NAME": {
            "PLACEHOLDER": "Unesite naziv tvrtke"
          }
        },
        "UPDATE_BUTTON": "Ažuriraj kontakt",
        "SUCCESS_MESSAGE": "Kontakt je uspješno ažuriran",
        "ERROR_MESSAGE": "Kontakt nije moguće ažurirati. Pokušajte ponovno kasnije."
      },
      "SOCIAL_MEDIA": {
        "TITLE": "Uredi društvene poveznice",
        "FORM": {
          "FACEBOOK": {
            "PLACEHOLDER": "Dodaj Facebook"
          },
          "GITHUB": {
            "PLACEHOLDER": "Dodaj Github"
          },
          "INSTAGRAM": {
            "PLACEHOLDER": "Dodaj Instagram"
          },
          "WHATSAPP": {
            "PLACEHOLDER": "Dodaj WhatsApp"
          },
          "LINKEDIN": {
            "PLACEHOLDER": "Dodaj LinkedIn"
          },
          "TWITTER": {
            "PLACEHOLDER": "Dodaj Twitter"
          }
        }
      }
    },
    "DETAILS": {
      "CREATED_AT": "Kreirano {date}",
      "LAST_ACTIVITY": "Zadnja aktivnost {date}",
      "DELETE_CONTACT_DESCRIPTION": "Trajno izbrišite ovaj kontakt. Ova radnja je nepovratna",
      "DELETE_CONTACT": "Izbriši kontakt",
      "DELETE_DIALOG": {
        "TITLE": "Potvrdi brisanje",
        "DESCRIPTION": "Jeste li sigurni da želite izbrisati kontakt {contactName}?",
        "CONFIRM": "Da, izbriši",
        "API": {
          "SUCCESS_MESSAGE": "Contact deleted successfully",
          "ERROR_MESSAGE": "Kontakt nije moguće izbrisati. Pokušajte ponovno kasnije."
        }
      },
      "AVATAR": {
        "UPLOAD": {
          "ERROR_MESSAGE": "Profilnu sliku nije moguće prenijeti. Pokušajte ponovno kasnije.",
          "SUCCESS_MESSAGE": "Profilna slika je uspješno prenesena"
        },
        "DELETE": {
          "SUCCESS_MESSAGE": "Profilna slika je uspješno izbrisana",
          "ERROR_MESSAGE": "Profilnu sliku nije moguće izbrisati. Pokušajte ponovno kasnije."
        }
      }
    },
    "SIDEBAR": {
      "TABS": {
        "ATTRIBUTES": "Atributi",
        "HISTORY": "History",
        "NOTES": "Bilješke",
        "MERGE": "Spoji",
        "ORDER_HISTORY": "Nedavne narudžbe",
        "RETINO": "Retino"
      },
      "HISTORY": {
        "EMPTY_STATE": "Nema prethodnih razgovora povezanih s ovim kontaktom"
      },
      "ATTRIBUTES": {
        "SEARCH_PLACEHOLDER": "Pretraži atribute",
        "UNUSED_ATTRIBUTES": "Nekorišteni atributi: {count}",
        "EMPTY_STATE": "U ovom računu nema dostupnih prilagođenih atributa kontakta. Prilagođeni atribut možete kreirati u postavkama.",
        "YES": "Da",
        "NO": "Ne",
        "TRIGGER": {
          "SELECT": "Odaberi vrijednost",
          "INPUT": "Unesite vrijednost"
        },
        "VALIDATIONS": {
          "INVALID_NUMBER": "Neispravan broj",
          "REQUIRED": "Potrebna je ispravna vrijednost",
          "INVALID_INPUT": "Neispravan unos",
          "INVALID_URL": "Neispravan URL",
          "INVALID_DATE": "Neispravan datum"
        },
        "NO_ATTRIBUTES": "Nema pronađenih atributa",
        "API": {
          "SUCCESS_MESSAGE": "Atribut je uspješno ažuriran",
          "DELETE_SUCCESS_MESSAGE": "Atribut je uspješno izbrisan",
          "UPDATE_ERROR": "Atribut nije moguće ažurirati. Pokušajte ponovno kasnije",
          "DELETE_ERROR": "Atribut nije moguće izbrisati. Pokušajte ponovno kasnije"
        }
      },
      "MERGE": {
        "TITLE": "Spoji kontakt",
        "DESCRIPTION": "Spojite dva profila u jedan, uključujući sve atribute i razgovore. U slučaju sukoba prednost imaju atributi primarnog kontakta.",
        "PRIMARY": "Primarni kontakt",
        "PRIMARY_HELP_LABEL": "Bit će spremljen",
        "PRIMARY_REQUIRED_ERROR": "Prije nastavka odaberite kontakt s kojim želite spojiti",
        "PARENT": "Bit će spojen",
        "PARENT_HELP_LABEL": "Bit će izbrisan",
        "EMPTY_STATE": "Nema pronađenih kontakata",
        "PLACEHOLDER": "Pretraži primarni kontakt",
        "SEARCH_PLACEHOLDER": "Pretraži kontakt",
        "SEARCH_ERROR_MESSAGE": "Pretraživanje kontakata nije uspjelo. Pokušajte ponovno kasnije.",
        "SUCCESS_MESSAGE": "Kontakt je uspješno spojen",
        "ERROR_MESSAGE": "Kontakte nije moguće spojiti. Pokušajte ponovno!",
        "IS_SEARCHING": "Tražim...",
        "BUTTONS": {
          "CANCEL": "Odustani",
          "CONFIRM": "Spoji kontakt"
        }
      },
      "NOTES": {
        "PLACEHOLDER": "Dodaj bilješku",
        "WROTE": "napisao/la",
        "YOU": "Vi",
        "SAVE": "Spremi bilješku",
        "EMPTY_STATE": "Uz ovaj kontakt nema bilježaka. Bilješku možete dodati upisom u polje iznad."
      }
    },
    "EMPTY_STATE": {
      "TITLE": "U ovom računu nema kontakata",
      "SUBTITLE": "Dodajte nove kontakte klikom na gumb ispod",
      "BUTTON_LABEL": "Dodaj kontakt",
      "SEARCH_EMPTY_STATE_TITLE": "Nijedan kontakt ne odgovara pretrazi 🔍",
      "LIST_EMPTY_STATE_TITLE": "U ovom prikazu nema kontakata 📋"
    }
  },
  "COMPOSE_NEW_CONVERSATION": {
    "TITLE": "Novi razgovor",
    "CONTACT_SEARCH": {
      "ERROR_MESSAGE": "We couldn’t complete the search. Please try again."
    },
    "FORM": {
      "GO_TO_CONVERSATION": "Pregled",
      "SUCCESS_MESSAGE": "Poruka je uspješno poslana!",
      "ERROR_MESSAGE": "Došlo je do pogreške pri kreiranju razgovora. Pokušajte ponovno kasnije.",
      "NO_INBOX_ALERT": "Nema dostupnih sandučića za pokretanje razgovora s ovim kontaktom.",
      "CONTACT_SELECTOR": {
        "LABEL": "Za:",
        "TAG_INPUT_PLACEHOLDER": "Pretražite kontakt po imenu, e-pošti ili broju telefona",
        "CONTACT_CREATING": "Kreiranje kontakta..."
      },
      "INBOX_SELECTOR": {
        "LABEL": "Putem:",
        "BUTTON": "Prikaži sandučiće"
      },
      "EMAIL_OPTIONS": {
        "SUBJECT_LABEL": "Predmet:",
        "SUBJECT_PLACEHOLDER": "Ovdje unesite predmet e-pošte",
        "CC_LABEL": "Cc:",
        "CC_PLACEHOLDER": "Pretražite kontakt po adresi e-pošte",
        "BCC_LABEL": "Bcc:",
        "BCC_PLACEHOLDER": "Pretražite kontakt po adresi e-pošte",
        "BCC_BUTTON": "Bcc"
      },
      "MESSAGE_EDITOR": {
        "PLACEHOLDER": "Ovdje napišite poruku..."
      },
      "WHATSAPP_OPTIONS": {
        "LABEL": "Odaberi predložak",
        "SEARCH_PLACEHOLDER": "Pretraži predloške",
        "EMPTY_STATE": "Nema pronađenih predložaka",
        "TEMPLATE_PARSER": {
          "TEMPLATE_NAME": "WhatsApp predložak: {templateName}",
          "VARIABLES": "Varijable",
          "BACK": "Natrag",
          "SEND_MESSAGE": "Pošalji poruku"
        }
      },
      "ACTION_BUTTONS": {
        "SEND": "Pošalji ({keyCode})",
        "MARK_RESOLVED": "Označi novi razgovor kao riješen nakon slanja",
        "SAVE_DRAFT": "Spremi skicu",
        "CREATE_AS_INTERNAL": "Kreiraj kao razgovor s bilješkom",
        "SEND_AND_RESOLVE_ORIGINAL": "Pošalji i riješi izvorni razgovor ({keyCode})"
      },
      "DISCARD": "Odbaci skicu",
      "DISCARD_MODAL": {
        "TITLE": "Odbaci skicu",
        "DESCRIPTION": "Jeste li sigurni da želite odbaciti ovu skicu?",
        "CONFIRM": "Da, odbaci",
        "CANCEL": "Ne, zadrži"
      }
    }
  }
}
